import { getPerson } from './people';
import { formatValuation } from './scoring';
import { ROLES, ROLE_LABELS, type Result, type Roster } from './types';

export const buildShareText = (roster: Roster, result: Result): string => {
  const lines = ROLES.map((role) => {
    const pick = roster[role];
    return `${ROLE_LABELS[role]} — ${pick ? getPerson(pick.personId).name : '—'}`;
  });

  return [
    'MY 1-T COMPANY',
    '',
    ...lines,
    '',
    `VALUATION: ${formatValuation(result.valuation)}`,
    `CHAOS: ${result.scores.chaos}/100`,
    '',
    result.headline.toUpperCase(),
    result.summary.join(' '),
  ].join('\n');
};
